import api from '../services/api.service';
import { API_ROUTES } from '../constants/apiRoutes';
import { extractData } from '../utils/helpers/extractDataHelper';

const schema = {
  getImportantTasksRequest: async () => {
    try {
      const response = await api.get(API_ROUTES.IMPORTANT_TASKS);
      return extractData(response);
    } catch (error) {
      return error;
    }
  },
};

export default schema;
